import { ReactNode, useEffect, useRef, useState } from 'react'

import { observer } from 'mobx-react-lite'

import umraListStore from 'entities/umrah/models/umrah-list.ts'
import userStore from 'entities/user/module/user-store'

import { useInfiniteScroll } from 'shared/hooks/use-infinity-scroll.ts'

import { UmrahPromo, UmrahPromoKey } from '../index'

interface Props {
  children: ReactNode
}

export const UmrahPromoWrapper = observer(({ children }: Props) => {
  const targetRef = useRef<HTMLDivElement>(null!)

  const [isShowPromo, setIsShowPromo] = useState(
    Boolean(userStore.getClientStateString(UmrahPromoKey)),
  )

  useEffect(() => {
    setIsShowPromo(Boolean(userStore.getClientStateString(UmrahPromoKey)))
  }, [userStore.client_state])

  const handleClosePromo = () => {
    setIsShowPromo(true)
  }

  useInfiniteScroll({
    targetRef,
    canLoad: umraListStore.maxPage >= umraListStore.page,
    rootMargin: '50px',
    trigger: isShowPromo,
    onLoad: () => {
      void umraListStore.requestUmrahList()
    },
  })

  if (!isShowPromo) {
    return <UmrahPromo onClose={handleClosePromo} />
  }

  return (
    <>
      {children}
      <div ref={targetRef} />
    </>
  )
})
